import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');
  const [autoLoginSuccess, setAutoLoginSuccess] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Kein Verifizierungs-Token gefunden.');
        return;
      }

      try {
        const response = await axios.get(`${API}/api/auth/verify-email?token=${token}`);
        setStatus('success');
        setMessage(response.data.message);
        
        // Auto-Login wenn Token zurückgegeben wurde
        if (response.data.auto_login && response.data.access_token) {
          // Token speichern
          localStorage.setItem('token', response.data.access_token);
          // Axios Default Header setzen
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.access_token}`;
          setAutoLoginSuccess(true);
          
          // Nach 2 Sekunden zum Main-Hub weiterleiten
          setTimeout(() => {
            navigate('/main-hub');
          }, 2000);
        } else {
          // Fallback: Zur Landing-Page weiterleiten
          setTimeout(() => {
            navigate('/');
          }, 3000);
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Email-Verifizierung fehlgeschlagen.');
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/burningteam-logo.png"
            alt="BurningTeam"
            className="h-16 mx-auto mb-4"
          />
        </div>

        {status === 'loading' && (
          <div className="text-center">
            <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-purple-600 mx-auto mb-4"></div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Email wird verifiziert...</h2>
            <p className="text-gray-600">Bitte warten Sie einen Moment.</p>
          </div>
        )}

        {status === 'success' && (
          <div className="text-center">
            <div className="bg-green-100 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">✅ Email erfolgreich verifiziert!</h2>
            <p className="text-gray-600 mb-4">{message}</p>
            
            {autoLoginSuccess ? (
              <div className="bg-blue-50 rounded-lg p-4 mb-4">
                <div className="flex items-center justify-center gap-2 text-blue-700">
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                  <span className="font-semibold">Du wirst automatisch angemeldet...</span>
                </div>
                <p className="text-sm text-blue-600 mt-2">Weiterleitung zur App erfolgt in Kürze</p>
              </div>
            ) : (
              <p className="text-sm text-gray-500">Du wirst zur Startseite weitergeleitet...</p>
            )}
          </div>
        )}

        {status === 'error' && (
          <div className="text-center">
            <div className="bg-red-100 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">❌ Verifizierung fehlgeschlagen</h2>
            <p className="text-gray-600 mb-6">{message}</p>
            <button
              onClick={() => navigate('/')}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition"
            >
              Zur Startseite
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
